<template>
<div class="chapter">
<div class="inner_page">
<p class="indent">Four of the most important battles of the early period of the war were fought in this area during 1915; battles in which – with the exception of Neuve Chapelle which was an entirely British affair – the BEF was very much the junior partner in the Franco-British Alliance. It was a period when the strategic direction of the war on the Western Front was for the most part dictated by the French and their Commander-in-Chief, General Joseph Joffre.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 19_fm032.vue?43798da0